import React from 'react';
import { HERO } from '@/constants/content';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden"
      style={{ background: 'linear-gradient(to bottom, #eff6ff 0%, #ffffff 100%)' }}
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column: Copy */}
          <div className="space-y-8">
            {/* Trust Badge */}
            <div
              className="inline-flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-full px-4 py-2"
              data-testid="trust-badge"
            >
              <Shield className="w-4 h-4 text-blue-700" />
              <span className="text-sm font-medium text-blue-900">
                {HERO.trustBadge}
              </span>
            </div>

            {/* H1 */}
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight"
              style={{ fontFamily: 'Manrope, sans-serif' }}
              data-testid="hero-title"
            >
              {HERO.title}
            </h1>

            {/* Subtitle */}
            <p
              className="text-base sm:text-lg text-gray-600 leading-relaxed"
              data-testid="hero-subtitle"
            >
              {HERO.subtitle}
            </p>
          </div>

          {/* Right Column: Dashboard Mockup */}
          <div className="relative" data-testid="hero-mockup">
            <div className="relative rounded-2xl shadow-2xl overflow-hidden">
              {/* Dashboard Real Screenshot */}
              <img
                src="/dashboard-preview-new.png"
                alt="Dashboard INDEXONE - SGDEA"
                className="w-full h-auto"
                data-testid="hero-dashboard-image"
              />
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full blur-3xl opacity-20" style={{ backgroundColor: '#D7A22F' }}></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-blue-500 rounded-full blur-3xl opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
};